import { render, staticRenderFns } from "./confirmDeletionLeadgidModal.vue?vue&type=template&id=d05a2fce&"
import script from "./confirmDeletionLeadgidModal.vue?vue&type=script&lang=js&"
export * from "./confirmDeletionLeadgidModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports